export const playAudio = (src: string) => new Audio(src).play();
